import { useCallback } from 'react'
import { useAppStore } from '@/store'
import type { FeatureKey } from './features'

/**
 * `isEnabled(feature)` for the signed-in user. Everything counts as enabled
 * until their list has loaded, matching the backend default.
 */
export function useFeatureAccess(): {
  isEnabled: (feature: FeatureKey) => boolean
  loaded: boolean
} {
  const userId = useAppStore((s) => s.user?.userId ?? null)
  const enabled = useAppStore((s) => s.enabledFeatures)
  const ownerId = useAppStore((s) => s.featureAccessUserId)
  const current =
    userId !== null && ownerId === userId && Array.isArray(enabled) ? enabled : null
  const isEnabled = useCallback(
    (feature: FeatureKey) => current === null || current.includes(feature),
    [current]
  )
  return { isEnabled, loaded: current !== null }
}

export function useFeatureEnabled(feature: FeatureKey): boolean {
  return useFeatureAccess().isEnabled(feature)
}
